import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authStore } from '../../stores/authStore';
import { Loader } from 'lucide-react';

const ProtectedRoute = ({ children, permission = null }) => {
  const location = useLocation();
  const { isAuthenticated, user, hasPermission } = authStore();
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // Simula verificação de autenticação
    const timer = setTimeout(() => setLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader className="animate-spin h-8 w-8 text-primary-500" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verifica permissão específica se fornecida
  if (permission) {
    const { module, action = 'view' } = permission;
    if (!hasPermission(module, action)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;